<template>
  <span :class="`svg ${type}`">
    <svg
      v-if="type === 'arrow-right'"
      :width="width"
      :height="height"
      viewBox="0 0 20.3 12.8"
    >
      <g transform="translate(0 0.61)">
        <rect x="5.8" y="4.7" width="13.1" height="2"/>
        <rect y="4.7" width="2.8" height="2"/>
        <polygon points="15.4,12.2 13.8,11 17.8,5.8 13.8,0.6 15.4,-0.6 20.3,5.8"/>
      </g>
    </svg>

    <svg
      v-else-if="type === 'arrow-left'"
      :width="width"
      :height="height"
      viewBox="0 0 20.3 12.8"
    >
      <g transform="translate(0 0.61)">
        <rect x="1.3" y="4.7" class="st0" width="13.1" height="2"/>
        <rect x="17.5" y="4.7" class="st0" width="2.8" height="2"/>
        <polygon class="st0" points="4.9,12.2 6.5,11 2.5,5.8 6.5,0.6 4.9,-0.6 0,5.8"/>
      </g>
    </svg>

    <svg
      v-else-if="type === 'chevron-down'"
      :width="width"
      :height="height"
      viewBox="0 0 7.7 4.5"
    >
      <g transform="translate(478.396 -491.639) rotate(90)">
        <polygon points="496.1,474.5 492.4,478.4 491.6,477.7 494.7,474.5 491.6,471.4 492.4,470.6"/>
      </g>
    </svg>

    <svg
      v-else-if="type === 'chevron-up'"
      :width="width"
      :height="height"
      viewBox="0 0 7.7 4.5"
    >
      <g transform="translate(478.396 -491.639) rotate(90)">
        <polygon points="491.6,474.5 495.4,478.4 496.1,477.7 493,474.5 496.1,471.4 495.4,470.6"/>
      </g>
    </svg>

    <svg
      v-else-if="type === 'medal'"
      :width="width"
      :height="height"
      viewBox="0 0 14.4 20.6"
    >
      <path d="M7.2,20.6c-4,0-7.2-3.2-7.2-7.2s3.2-7.2,7.2-7.2s7.2,3.2,7.2,7.2c0,0,0,0,0,0C14.4,17.4,11.2,20.6,7.2,20.6z M7.2,18.5c2.8,0,5.2-2.3,5.2-5.2s-2.3-5.2-5.2-5.2s-5.2,2.3-5.2,5.2c0,0,0,0,0,0C2.1,16.2,4.4,18.5,7.2,18.5z M7.2,6.2 c-0.6,0-1-0.5-1-1s0.5-1,1-1c0.6,0,1,0.5,1,1S7.8,6.2,7.2,6.2L7.2,6.2z M4.1,0h2.1v4.1C5,4.1,4.1,3.2,4.1,2.1V0z M8.2,0h2.1v2.1 c0,1.1-0.9,2.1-2.1,2.1L8.2,0z"/>
    </svg>

    <svg
      v-else-if="type === 'play'"
      :width="width"
      :height="height"
      viewBox="0 0 17.9 21.5"
    >
      <g transform="translate(14 3.532) rotate(90)">
        <path class="st1" d="M7.2,0L0,12h14.4L7.2,0 M7.2-3.9L17.9,14H-3.5L7.2-3.9z"/>
      </g>
    </svg>

    <svg
      v-else-if="type === 'pause'"
      :width="width"
      :height="height"
      viewBox="0 0 73.3 73"
    >
      <g>
        <path d="M0.5,0.5v71.9h32.6V0.5H0.5z M26.1,65.1H8.5V8.5h17.6V65.1z"/>
        <path d="M33.6,72.9H0V0h33.6V72.9z M1,71.9h31.6V1H1V71.9z M26.6,65.6H8V8h18.6V65.6z M9,64.6h16.6V9H9V64.6z"/>
      </g>
      <g>
        <path d="M40.2,0.6v71.9h32.6V0.6H40.2z M65.8,65.2H48.2V8.6h17.6V65.2z"/>
        <path d="M73.3,73H39.7V0.1h33.6V73z M40.7,72h31.6V1.1H40.7V72z M66.3,65.7H47.7V8.1h18.6V65.7z M48.7,64.7h16.6V9.1H48.7V64.7z"/>
      </g>
    </svg>

    <svg
      v-else-if="type === 'mail'"
      :width="width"
      :height="height"
      viewBox="0 0 19.1 15.1"
    >
      <g transform="translate(-0.59 -3)">
        <path class="st0" d="M16.7,18.1H3.6c-1.4,0-2.6-1.2-2.6-2.6V5.6C1,4.2,2.2,3,3.6,3c0,0,0,0,0,0h13.1c1.4,0,2.6,1.2,2.6,2.6v9.8 C19.3,16.9,18.1,18.1,16.7,18.1z M3.6,5C3.3,5,3,5.3,3,5.6v9.8c0,0.3,0.3,0.6,0.6,0.6h13.1c0.3,0,0.6-0.3,0.6-0.6V5.6 C17.3,5.3,17,5,16.7,5H3.6z"/>
        <path class="st0" d="M10.2,13.3c-0.2,0-0.5-0.1-0.7-0.2l-8.2-7c-0.4-0.4-0.5-1-0.1-1.4c0.4-0.4,1-0.5,1.4-0.1l7.5,6.4l7.5-6.4 c0.4-0.4,1.1-0.3,1.4,0.1c0.4,0.4,0.3,1.1-0.1,1.4l-8.2,7C10.6,13.3,10.4,13.3,10.2,13.3z"/>
      </g>
    </svg>

    <svg
      v-else-if="type === 'apple'"
      :width="width"
      :height="height"
      viewBox="0 0 16 23"
      style="fill:#fff;font-size:20px;font-family:HelveticaNeue, Helvetica Neue;"
    >
      <text transform="translate(0 19)"><tspan x="0" y="0"></tspan></text>
    </svg>

    <svg
      v-else-if="type === 'facebook'"
      :width="width"
      :height="height"
      viewBox="0 0 1365.3 1357"
    >
      <g id="g10" transform="matrix(1.3333333,0,0,-1.3333333,0,1357.04)">
        <g id="g12" transform="scale(0.1)">
          <path id="path14" class="st0" d="M10240,5057.8c0,2827.7-2292.3,5120-5120,5120S0,7885.5,0,5057.8C0,2502.3,1872.3,384.1,4320,0 v3577.8H3020v1480h1300v1128c0,1283.2,764.4,1992,1933.9,1992c560.2,0,1146.1-100,1146.1-100v-1260h-645.6 c-636,0-834.4-394.7-834.4-799.6v-960.4h1420l-227-1480H5920V0C8367.7,384.1,10240,2502.3,10240,5057.8"/>
        </g>
      </g>
    </svg>

    <svg
      v-else-if="type === 'eye'"
      :width="width"
      :height="height"
      viewBox="0 0 20 12.856"
    >
      <g transform="translate(-2.252 -7.875)">
        <path class="a" d="M12.241,7.875c-3.589,0-6.419,2.259-9.8,5.95a.706.706,0,0,0,0,.951c2.9,3.2,5.451,5.955,9.807,5.955,4.3,0,7.531-3.469,9.825-5.982a.7.7,0,0,0,.022-.924C19.749,10.991,16.513,7.875,12.241,7.875Zm.2,10.441a4.017,4.017,0,1,1,3.826-3.826A4.019,4.019,0,0,1,12.437,18.316Z" transform="translate(0 0)"/>
        <path class="a" d="M16.357,14.259A2.1,2.1,0,0,1,16.5,13.5c-.045,0-.089,0-.138,0a2.857,2.857,0,1,0,2.857,2.857c0-.058,0-.116,0-.174a1.98,1.98,0,0,1-.812.174A2.072,2.072,0,0,1,16.357,14.259Z" transform="translate(-4.107 -2.054)"/>
      </g>
    </svg>

    <svg
      v-else-if="type === 'eye-off'"
      :width="width"
      :height="height"
      viewBox="0 0 20 17.146"
    >
      <g transform="translate(-2.252 -4.499)">
        <path class="a" d="M5.587,4.683a.635.635,0,0,0-.9.9L20.562,21.462a.629.629,0,0,0,.612.161.619.619,0,0,0,.286-.165.633.633,0,0,0,0-.893Z" transform="translate(-0.823 0)"/>
        <g transform="translate(2.252 6.643)">
          <path class="a" d="M12.44,19.653A4.015,4.015,0,0,1,8.622,13.92L6.238,11.531a31.32,31.32,0,0,0-3.8,3.63.706.706,0,0,0,0,.951c2.9,3.2,5.452,5.956,9.81,5.956a8.6,8.6,0,0,0,3.675-.857l-1.942-1.942A4.057,4.057,0,0,1,12.44,19.653Z" transform="translate(-2.252 -9.209)"/>
          <path class="a" d="M25.7,14.751a.7.7,0,0,0,.022-.924c-2.335-2.835-5.572-5.952-9.845-5.952a8.358,8.358,0,0,0-3.661.848l1.951,1.951a3.934,3.934,0,0,1,1.531-.384,4.015,4.015,0,0,1,3.818,5.733l2.389,2.389A29.535,29.535,0,0,0,25.7,14.751Z" transform="translate(-5.89 -7.875)"/>
          <path class="a" d="M13.509,17.741a2.869,2.869,0,0,0,2.63,2.63,2.791,2.791,0,0,0,1.045-.116l-3.563-3.563A2.921,2.921,0,0,0,13.509,17.741Z" transform="translate(-6.358 -11.093)"/>
          <path class="a" d="M21.951,17.9c0-.058,0-.116,0-.174a1.98,1.98,0,0,1-.813.174c-.049,0-.094,0-.138,0l.83.835A2.855,2.855,0,0,0,21.951,17.9Z" transform="translate(-9.093 -11.47)"/>
          <path class="a" d="M17.525,14.259a2.1,2.1,0,0,1,.138-.755c-.045,0-.089,0-.138,0a2.825,2.825,0,0,0-.826.125l.835.835C17.53,14.393,17.525,14.326,17.525,14.259Z" transform="translate(-7.525 -9.928)"/>
        </g>
      </g>
    </svg>

    <svg
      v-else-if="type === 'close'"
      :width="width"
      :height="height"
      viewBox="0 0 8.3 8.3"
    >
      <path class="st0" d="M8.2,6.6L8.2,6.6L5.7,4.1l2.5-2.5l0,0c0.1-0.1,0.1-0.3,0-0.4c0,0,0,0,0,0L7,0.1C6.9,0,6.7,0,6.6,0.1l0,0 L4.1,2.6L1.6,0.1l0,0C1.5,0,1.4,0,1.3,0.1c0,0,0,0,0,0L0.1,1.3C0,1.4,0,1.5,0.1,1.6c0,0,0,0,0,0l0,0l2.5,2.5L0.1,6.6l0,0 C0,6.7,0,6.9,0.1,7c0,0,0,0,0,0l1.2,1.2c0.1,0.1,0.3,0.1,0.4,0c0,0,0,0,0,0l0,0l2.5-2.5l2.5,2.5l0,0c0.1,0.1,0.3,0.1,0.4,0 c0,0,0,0,0,0L8.2,7C8.3,6.9,8.3,6.7,8.2,6.6C8.2,6.6,8.2,6.6,8.2,6.6L8.2,6.6z"/>
    </svg>

    <svg
      v-else-if="type === 'info'"
      :width="width"
      :height="height"
      viewBox="0 0 16 16"
    >
      <path d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M7,3h2v2H7V3z M10,13H9H8H7V7h2v4h1V13z"/>
    </svg>

    <svg
      v-else-if="type === 'camera'"
      :width="width"
      :height="height"
      viewBox="0 0 35 29"
    >
      <g transform='translate(-0.5 -3.5)'>
        <path d='M31.5,32.5h-27c-2.2,0-4-1.8-4-4V12c0-2.2,1.8-4,4-4H10l2.7-4.1c0.2-0.3,0.5-0.4,0.8-0.4h9 c0.3,0,0.6,0.2,0.8,0.4L26,8h5.5c2.2,0,4,1.8,4,4v10.6c0,0.6-0.4,1-1,1s-1-0.4-1-1V12c0-1.1-0.9-2-2-2h-6c-0.3,0-0.6-0.2-0.8-0.4 L22,5.5H14l-2.7,4.1c-0.2,0.3-0.5,0.4-0.8,0.4h-6c-1.1,0-2,0.9-2,2v16.5c0,1.1,0.9,2,2,2h27c1.1,0,2-0.9,2-2c0-0.6,0.4-1,1-1 s1,0.4,1,1C35.5,30.7,33.7,32.5,31.5,32.5z'/>
        <path d='M18,26.5c-3.9,0-7-3.1-7-7c0-3.9,3.1-7,7-7c3.9,0,7,3.1,7,7C25,23.4,21.9,26.5,18,26.5z M18,14.5 c-2.8,0-5,2.2-5,5s2.2,5,5,5s5-2.2,5-5S20.8,14.5,18,14.5z'/>
      </g>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: 16,
    },
    height: {
      type: Number,
      default: 16,
    },
  },
};
</script>

<style lang="scss" scoped>
.svg {
  display: inline-block;

  svg {
    display: block;
  }
}
</style>
